import { render, staticRenderFns } from "./m-history-list.vue?vue&type=template&id=666f04dc&scoped=true&"
import script from "./m-history-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-history-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-history-list.vue?vue&type=style&index=0&id=666f04dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f04dc",
  null
  
)

export default component.exports